export const toCssPos = (p) => ({
    top : p.y,
    left: p.x,
});
